'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (key, val) {
    if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'symbol') {
        return val.toString();
    }
    if (Number.isNaN(val)) {
        return 'NaN';
    }
    switch (val) {
        case undefined:
            return 'undefined';
        case null:
            return 'null';
        case Infinity:
            return 'Infinity';
        case -Infinity:
            return '-Infinity';
        default:
            return val;
    }
};
//# sourceMappingURL=stringifySpecialTypesReplacer.js.map